import {
  useCurriculum,
  useSubject,
  useSubjectPlan,
} from "@twinkltech/curriculum-architect-domain-hooks";
import { useParams } from "react-router-dom";

import { mapApiDataToTableReducer } from "@/utils/mapApiDataToTableReducer/mapApiDataToTableReducer";

import { SubjectPlanOverview } from "./SubjectPlanOverview";

export const SubjectPlanOverviewContainer = () => {
  const { curriculum_id, subject_id } = useParams();

  if (!curriculum_id || !subject_id) {
    throw new Error("curriculum_id and subject_id are required");
  }

  const {
    data: curriculum,
    error: curriculumError,
    isLoading: isLoadingCurriculum,
  } = useCurriculum({
    id: curriculum_id,
  });

  const {
    data: subjectPlan,
    error: subjectPlanError,
    isLoading,
  } = useSubjectPlan({
    curriculumId: curriculum_id,
    subjectId: subject_id,
  });

  const {
    actions: { update: updateSubject },
    data: subject,
    error: subjectError,
  } = useSubject({ subjectId: subject_id, curriculumId: curriculum_id });

  const mappedTableData = mapApiDataToTableReducer(subjectPlan);

  return (
    <SubjectPlanOverview
      curriculum={curriculum}
      error={curriculumError || subjectPlanError || subjectError}
      isLoading={isLoading || isLoadingCurriculum}
      resources={mappedTableData.resources}
      subject={subject || undefined}
      tableData={mappedTableData}
      onUpdateSubjectStatus={updateSubject.apply}
    />
  );
};
